import type { ZodType } from 'zod';
import { z } from 'zod';
import {
  type CprContactFilterRequest,
  type CprContactGroupMember,
  MarketRole,
} from '#pie/internal/api/pie-bff';
import { getValues } from '#pie/utils/ZodUtils';
import { createFiltersAtom } from './createFiltersAtom';
import { createSortingAtom } from './createSortingAtom';
import type { DefaultSorting } from './defaultSorting';

export const defaultCprContactGroupDetailFilters = {
  marketPartyIds: [],
  marketRoles: [],
  organisationIds: [],
} satisfies z.infer<typeof cprContactGroupDetailFiltersSchema>;

export const cprContactGroupDetailFiltersSchema: ZodType<
  CprContactFilterRequest,
  unknown
> = z
  .object({
    marketPartyIds: z.array(z.string()).optional(),
    marketRoles: z.array(z.enum(getValues(MarketRole))).optional(),
    organisationIds: z.array(z.string()).optional(),
  })
  .catch(defaultCprContactGroupDetailFilters);

export const cprContactGroupDetailFiltersAtom =
  createFiltersAtom<CprContactFilterRequest>({
    defaultFilters: defaultCprContactGroupDetailFilters,
    filtersSchema: cprContactGroupDetailFiltersSchema,
  });

export const defaultCprContactGroupDetailSorting: DefaultSorting<CprContactGroupMember> =
  {
    desc: false,
    id: 'marketParty.name',
  };

export const cprContactGroupDetailSortingAtom = createSortingAtom({
  defaultSorting: defaultCprContactGroupDetailSorting,
});
